import Svg, { Mask, Path } from '@rd-core-svg/svg'
import type { FlagsSvgProps } from '../svg.types'

export const SantanderSmall = (props: FlagsSvgProps) => {
  return (
    <Svg width={36} height={24} viewBox="0 0 36 24" fill="none" {...props}>
      <Mask id="path-1-inside-1_22078_4048" fill="white">
        <Path d="M0 4C0 1.79086 1.79086 0 4 0H32C34.2091 0 36 1.79086 36 4V20C36 22.2091 34.2091 24 32 24H4C1.79086 24 0 22.2091 0 20V4Z" />
      </Mask>
      <Path
        d="M0 4C0 1.79086 1.79086 0 4 0H32C34.2091 0 36 1.79086 36 4V20C36 22.2091 34.2091 24 32 24H4C1.79086 24 0 22.2091 0 20V4Z"
        fill="#CC0000"
      />
      <Path
        d="M4 0V1H32V0V-1H4V0ZM36 4H35V20H36H37V4H36ZM32 24V23H4V24V25H32V24ZM0 20H1V4H0H-1V20H0ZM4 24V23C2.34315 23 1 21.6569 1 20H0H-1C-1 22.7614 1.23858 25 4 25V24ZM36 20H35C35 21.6569 33.6569 23 32 23V24V25C34.7614 25 37 22.7614 37 20H36ZM32 0V1C33.6569 1 35 2.34315 35 4H36H37C37 1.23858 34.7614 -1 32 -1V0ZM4 0V-1C1.23858 -1 -1 1.23858 -1 4H0H1C1 2.34315 2.34315 1 4 1V0Z"
        fill="#E6E6E6"
        mask="url(#path-1-inside-1_22078_4048)"
      />
      <Path
        d="M21.2873 11.4434C21.2531 10.9374 21.1161 10.4313 20.8421 9.99278L18.5134 5.97831C18.3422 5.6747 18.2052 5.33735 18.1367 5L18.034 5.16867C17.4518 6.14699 17.4518 7.39518 18.034 8.3735L19.9175 11.5783C20.4997 12.5566 20.4997 13.8048 19.9175 14.7831L19.8148 14.9518C19.7463 14.6145 19.6093 14.2771 19.4381 13.9735L17.7258 11.0386L16.6299 9.1494C16.4587 8.84579 16.3217 8.50844 16.2532 8.17109L16.1505 8.33976C15.5683 9.31808 15.5683 10.5325 16.1505 11.5446L18.034 14.7494C18.6162 15.7277 18.6162 16.9759 18.034 17.9542L17.9313 18.1229C17.8628 17.7856 17.7258 17.4482 17.5546 17.1446L15.1916 13.1301C14.8834 12.5904 14.7464 11.9831 14.7464 11.3759C12.2465 12.0169 10.5 13.4 10.5 14.9856C10.5 17.2121 13.8561 19 17.9997 19C22.1434 19 25.4995 17.2121 25.4995 14.9856C25.5337 13.4675 23.8215 12.0843 21.2873 11.4434Z"
        fill="white"
      />
    </Svg>
  )
}
